import { useState } from 'react';
import { supabase } from '../supabaseClient';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Appel à la fonction RPC pour vérifier les identifiants
      const { data, error: rpcError } = await supabase.rpc('verifier_identifiants', {
        p_identifiant: username,
        p_mot_de_passe: password
      });

      if (rpcError) {
        console.error('Erreur RPC:', rpcError);
        setError('Erreur de connexion au serveur');
        setLoading(false);
        return;
      }

      // Si aucun résultat, identifiants invalides
      if (!data || data.length === 0) {
        setError('Identifiant ou mot de passe incorrect');
        setLoading(false);
        return;
      }

      // Authentification réussie
      const user = data[0];
      
      // Récupérer les informations du profil incluant les sections autorisées
      const { data: profilData, error: profilError } = await supabase
        .from('profils')
        .select('sections, niveau_acces, nom')
        .eq('id', user.profil_id)
        .single();
      
      if (profilError) {
        console.error('Erreur récupération profil:', profilError);
      }
      
      onLogin({ 
        id: user.id,
        username: username, 
        nom: user.nom,
        prenom: user.prenom,
        profil_id: user.profil_id,
        email: user.email,
        sections: profilData?.sections || [],
        niveau_acces: profilData?.niveau_acces || 1,
        profil_nom: profilData?.nom || 'Sans profil'
      });
    } catch (err) {
      console.error('Erreur lors de la connexion:', err);
      setError('Une erreur est survenue');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      background: 'linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%)',
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        backgroundColor: '#ffffff',
        padding: '50px',
        borderRadius: '20px',
        width: '450px',
        border: '2px solid #1aabf9',
        boxShadow: '0 10px 40px rgba(26, 171, 249, 0.15)'
      }}>
        <h2 style={{ 
          textAlign: 'center',
          marginBottom: '40px',
          color: '#1aabf9',
          fontSize: '32px',
          fontWeight: '600',
          letterSpacing: '1px'
        }}>
          Connexion
        </h2>
        {error && (
          <div style={{
            backgroundColor: '#f8d7da',
            color: '#721c24',
            padding: '12px 18px',
            borderRadius: '8px',
            marginBottom: '20px',
            border: '1px solid #f5c6cb',
            fontSize: '14px'
          }}>
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '25px' }}>
            <label style={{ 
              display: 'block',
              marginBottom: '8px',
              color: '#495057',
              fontSize: '14px',
              fontWeight: '600'
            }}>
              Nom d'utilisateur
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{
                width: '100%',
                padding: '14px 18px',
                backgroundColor: '#f8f9fa',
                color: '#212529',
                border: '1px solid #dee2e6',
                borderRadius: '10px',
                fontSize: '15px',
                outline: 'none',
                transition: 'all 0.3s ease'
              }}
              onFocus={(e) => {
                e.target.style.border = '2px solid #1aabf9';
                e.target.style.backgroundColor = '#ffffff';
              }}
              onBlur={(e) => {
                e.target.style.border = '1px solid #dee2e6';
                e.target.style.backgroundColor = '#f8f9fa';
              }}
              required
            />
          </div>
          <div style={{ marginBottom: '35px' }}>
            <label style={{ 
              display: 'block',
              marginBottom: '8px',
              color: '#495057',
              fontSize: '14px',
              fontWeight: '600'
            }}>
              Mot de passe
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: '100%',
                padding: '14px 18px',
                backgroundColor: '#f8f9fa',
                color: '#212529',
                border: '1px solid #dee2e6',
                borderRadius: '10px',
                fontSize: '15px',
                outline: 'none',
                transition: 'all 0.3s ease'
              }}
              onFocus={(e) => {
                e.target.style.border = '2px solid #1aabf9';
                e.target.style.backgroundColor = '#ffffff';
              }}
              onBlur={(e) => {
                e.target.style.border = '1px solid #dee2e6';
                e.target.style.backgroundColor = '#f8f9fa';
              }}
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '16px',
              backgroundColor: loading ? '#6c757d' : '#1aabf9',
              color: '#ffffff',
              border: 'none',
              borderRadius: '10px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(26, 171, 249, 0.3)'
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 25px rgba(26, 171, 249, 0.4)';
                e.target.style.backgroundColor = '#0d96e6';
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 15px rgba(26, 171, 249, 0.3)';
                e.target.style.backgroundColor = '#1aabf9';
              }
            }}
          >
            {loading ? 'Connexion en cours...' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;